export default function copyToClipboard(text) {
    navigator.clipboard.writeText(text).catch((err) => alert('Failed to copy: ' + err));
}
